import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { get } from 'lodash'
import { compose } from 'recompose'

import { tasks as tasksApi } from 'redux/modules/api'
import { logError, modal, notification } from 'redux/modules/app'
import { areAllSelectedForBulk, mapRegistrationsForBulk } from 'redux/selectors/awardLeaderRegistrations'

function decorator(config = {}) {
  return ComposedComponent => {
    const enhance = compose(
      connect(
        state => ({
          local: {
            tasks: state.api.tasks.registrationAwardLeaders
          },
          selectableAwardLeaderIds: mapRegistrationsForBulk(state),
          areAllAwardLeadersSelected: areAllSelectedForBulk(state),
          commonLimit: state.app.commonLimit
        }),
        {
          ...tasksApi.registrationAwardLeaders,
          notification,
          modal,
          logError,
          bulkSelectAwardLeaders: tasksApi.registrationAwardLeaders.toggleTasksAwardLeadersAllSelected
        }
      )
    )

    class TasksRegistrationAwardLeaders extends Component {
      static propTypes = {
        tasks: PropTypes.object,
        decoFilter: PropTypes.string,
        local: PropTypes.object.isRequired,
        getTasksRegistrationAwardLeaders: PropTypes.func.isRequired,
        exportTasksRegistrationAwardLeaders: PropTypes.func.isRequired,
        confirmAwardLeaderEmail: PropTypes.func,
        commonLimit: PropTypes.number,
        modal: PropTypes.func,
        logError: PropTypes.func.isRequired,
        setTasksAwardLeadersSelected: PropTypes.func,
        setAwardLeadersParams: PropTypes.func
      }

      componentDidMount() {
        const { local, commonLimit, setAwardLeadersParams } = this.props

        if (config.useCommonLimit && commonLimit) {
          config.tasks && setAwardLeadersParams({ limit: commonLimit })
        } else {
          config.tasks &&
          this.handleGetTasksRegistrationAwardLeaders(
            local.tasks,
            this.handleGetBaseFilter()
          )
        }
      }

      componentWillReceiveProps(nextProps) {
        const { local } = this.props
        const { filter, limit, offset, sort, invalidate } = nextProps.local.tasks

        if (
          local.tasks.filter !== filter ||
          local.tasks.limit !== limit ||
          local.tasks.offset !== offset ||
          local.tasks.sort !== sort ||
          local.tasks.invalidate !== invalidate
        ) {
          config.tasks &&
            this.handleGetTasksRegistrationAwardLeaders(
              nextProps.local.tasks,
              this.handleGetBaseFilter()
            )
        }
      }

      handleGetBaseFilter = () => {
        const { params, decoFilter } = this.props

        switch (decoFilter || config.filter) {
          case 'organizationLeaders':
            return `organization.flatHierarchy.parentOrganization.id=${params && params.id}`
          case 'awardUnitRegistrations':
            return `organization.id=${params && params.id}`
          default:
            return ''
        }
      }

      handleGetTasksRegistrationAwardLeaders = (tasks, baseFilter) =>
        this.props.getTasksRegistrationAwardLeaders(tasks, baseFilter)

      handleExportAwardLeaderRegistrations = () => {
        const { local } = this.props

        return this.props.exportTasksRegistrationAwardLeaders(
          local.tasks,
          this.handleGetBaseFilter()
        )
      }

      handleAwardLeaderRegistrationEdit = (fields, leaderId) => {
        if (![null, undefined].includes(get(fields, 'isEmailConfirmed'))) {
          return this.props
            .confirmAwardLeaderEmail(fields.isEmailConfirmed, leaderId)
            .then(() => {
              this.props.modal(null)

              config.tasks &&
                this.handleGetTasksRegistrationAwardLeaders(
                  this.props.local.tasks,
                  this.handleGetBaseFilter()
                )
            })
        }
      }

      handleSetAwardLeadersSelectedTo = (id, newVal) => {
        const ids = this.props.local.tasks.selectedIds || []
        const newIds = ids.filter(i => i !== id).concat(newVal ? [id] : [])

        this.props.setTasksAwardLeadersSelected(newIds)
      }

      render() {
        const newProps = {
          ...this.props,
          tasks: {
            ...this.props.tasks,
            registrationAwardLeaders: this.props.local.tasks
          },
          onAwardLeaderRegistrationEdit: this.handleAwardLeaderRegistrationEdit,
          exportAwardLeaderRegistrations: this
            .handleExportAwardLeaderRegistrations,
          local: undefined,
          setAwardLeadersSelectedTo: this.handleSetAwardLeadersSelectedTo
        }

        return <ComposedComponent {...newProps} />
      }
    }
    return enhance(TasksRegistrationAwardLeaders)
  }
}

export default decorator
